"use strict";

define('rs/form/formdiff/formdiff.view',['rs/form/form.view', 'rs/helper'], function (FormView, helper) {
  var FormDiffView = FormView.extend({
    templates: {
      'form.diff.init': 'renderDiffInitFragment'
    },
    renderInitFragment: function renderInitFragment() {
      return this.renderDiffInitFragment.apply(this, arguments);
    },
    setHighlight: function setHighlight(fo) {
      fo.getView().getContentElement().addClass('fo-diff-highlight');
    },
    setDiffMode: function setDiffMode(fo) {
      fo.getView().$el.addClass('fo-diff-mode');
    }
  });
  return FormDiffView;
});

